/**
 * Touch counterpart of the apparel pill table's desktop row hover.
 *
 * The apparel size table scrolls natively (overflow-x) and needs no scroll JS, but
 * the hover feedback (row badge fills black — see size-guide--table.liquid) has no
 * touch equivalent. This element wraps the table and flags the row under the finger
 * (`size-guide-pill-table__row--touched`) from pointerdown to pointerup/pointercancel,
 * mirroring the touch highlight `size-guide-scroll-sync` gives the footwear table.
 *
 * Mouse pointers are ignored: desktop keeps the pure :hover behaviour.
 *
 * The class lives inside the `customElements.get` guard so the script is safe to load
 * more than once (the table renders once per unit, in several panels).
 */
if (!customElements.get('size-guide-touch-highlight')) {
    class SizeGuideTouchHighlight extends HTMLElement {
        touchedRow = null;
        connectedCallback() {
            this.addEventListener('pointerdown', this.handlePointerDown);
        }
        disconnectedCallback() {
            this.removeEventListener('pointerdown', this.handlePointerDown);
            this.clear();
        }
        handlePointerDown = (event) => {
            if (event.pointerType !== 'touch')
                return;
            this.touchedRow = event.target.closest('.size-guide-pill-table__row');
            if (!this.touchedRow)
                return;
            this.touchedRow.classList.add('size-guide-pill-table__row--touched');
            // pointercancel: native scroll taking over the gesture — clear, or it sticks.
            window.addEventListener('pointerup', this.clear);
            window.addEventListener('pointercancel', this.clear);
        };
        clear = () => {
            this.touchedRow?.classList.remove('size-guide-pill-table__row--touched');
            this.touchedRow = null;
            window.removeEventListener('pointerup', this.clear);
            window.removeEventListener('pointercancel', this.clear);
        };
    }
    customElements.define('size-guide-touch-highlight', SizeGuideTouchHighlight);
}
